// extracted by mini-css-extract-plugin
export var addTagButtonOverride = "_cq-b";
export var colorBlue = "_cq-8";
export var colorDot = "_cq-0";
export var colorDotLarge = "_cq-2";
export var colorDotSmall = "_cq-1";
export var colorGreen = "_cq-7";
export var colorGrey = "_cq-3";
export var colorOrange = "_cq-5";
export var colorPink = "_cq-a";
export var colorPurple = "_cq-9";
export var colorRed = "_cq-4";
export var colorYellow = "_cq-6";